import '@/global.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import * as Sentry from '@sentry/react';
import { datadogRum } from '@datadog/browser-rum';

import { App } from './App';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme';
import { ScanlineOverlay } from '@/components/ScanlineOverlay';

const env = import.meta.env.MODE;

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: env,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: env === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

if (import.meta.env.VITE_DD_RUM_APPLICATION_ID && import.meta.env.VITE_DD_RUM_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DD_RUM_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
    site: import.meta.env.VITE_DD_RUM_SITE ?? 'datadoghq.com',
    service: 'sherlock-frontend',
    env: import.meta.env.VITE_DD_RUM_ENV ?? env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScanlineOverlay />
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
